import React from 'react';
import ReactPaginate from 'react-paginate';

export interface GridTableFooterProps {
  pagAtual: number;
  pageCount: number;
  totalRecords: number;
  forcePage: number;
  onPageChange: (event: { selected: number }) => void;
  totalRecordsText?: string;
  rightSlot?: React.ReactNode;
}

const GridTableFooter = ({
  pagAtual,
  pageCount,
  totalRecords,
  forcePage,
  onPageChange,
  totalRecordsText,
  rightSlot,
}: GridTableFooterProps) => (
  <div className="user-table__footer">
    <div className="user-table__footer-info">
      <span>
        Página {pagAtual} de {pageCount || 1}
      </span>
      <span>{totalRecordsText ?? `Total de registros: ${totalRecords}`}</span>
    </div>

    {pageCount > 1 ? (
      <ReactPaginate
        previousLabel="‹"
        nextLabel="›"
        breakLabel="..."
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={onPageChange}
        containerClassName="grid-usuario__paginate"
        pageClassName="grid-usuario__paginate-page"
        activeClassName="grid-usuario__paginate-page--active"
        forcePage={forcePage}
      />
    ) : (
      rightSlot ?? null
    )}
  </div>
);

export default GridTableFooter;
